import { Table, TableHead, TableCell, TableRow, TableBody } from "@mui/material";

const UnlicensedMatrix = () => {
  return (
    <div>
      <Table className="matrix-table">
        <TableHead>
          <TableCell colSpan={4} align="center">
            <h4>Unlicensed Evaluation Review Matrix</h4>
          </TableCell>
        </TableHead>
        <TableHead>
          <TableRow>
            <TableCell>Assessor</TableCell>
            <TableCell>Ratings</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell className="b-600">Master</TableCell>
            <TableCell>Steward</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="b-600">Chief Mate</TableCell>
            <TableCell>
              Able Bodied Seaman, Able Bodied Seaman Maintenance, Ordinary Seaman, GUDE, Bosun, MDR/Nurse, Store Keeper
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="b-600">1st Assistant Engineer</TableCell>
            <TableCell>Oiler, OMU, GUDE-E, WA, WIPER, QMED, QEE/QMEE, Pwr Elect</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="b-600">Steward</TableCell>
            <TableCell>Chief Cook, Steward Assistant, Steward Baker, Assistant Cook, 2nd Cook/Baker</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
  );
};

export default UnlicensedMatrix;
